module.exports = __webpack_public_path__ + "static/media/eu-urbanites-exposure-to-air-pollution.b0309248.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/help-and-guides/eu-urbanites-exposure-to-air-pollution.png
// module id = 831
// module chunks = 0